import React from 'react'
import Hero from '../components/Hero'
import Links from '../components/Links'
import KeyPoint from '../components/Key_Point'
import About from '../components/About'
import HowItWork from '../components/HowItWork'
import COREFEATURES from '../components/COREFEATURES'
import WhyChoesUs from '../components/WhyChoesUs'
import Join from '../components/Join'

export default function Home() {
  return (
    <>
      <Hero />
      <Links />
      <KeyPoint />
      <About />
      <HowItWork />
      <COREFEATURES />
      <WhyChoesUs />
      <Join />
    </>
  )
}
